<template>
  <div class="my-bikes">
    <div class="my-bikes-wrapper">
      <div class="my-bikes-heading">
        <h2 class="mb-3">{{ trans.text.myBikes.title }}</h2>
        <p class="color-dark-gray">Summary of your bikes.</p>
      </div>
      <div v-if="hasCompletedTransfer()" class="my-bikes-alert">
        <p class="my-bikes-alert__title">Transfer completed</p>
        <button
          class="btn btn-gray w-100"
          @click.prevent="hideCompletedMessage()"
        >
          Ok
        </button>
      </div>
      <div v-if="list.length === 0" class="my-bikes-main">
        <p class="my-bikes-main__name">You have no bikes</p>
        <div class="my-bikes-main__img">
          <img alt="" src="/assets/images/account/mybikes.jpg">
        </div>
        <a :href="`/${lang}/choose`" class="btn btn btn-green w-100 mb-32">Buy</a>
        <ul v-if="false" class="my-bikes-main__parameters">
          <li>
            <span class="num">0</span><sub>G</sub>
            <span class="gray">Max G-force</span>
          </li>
          <li>
            <span class="num">0</span><sub>s</sub>
            <span class="gray">Max air time</span>
          </li>
          <li>
            <span class="num">0</span><sub>km/h</sub>
            <span class="gray">Max speed</span>
          </li>
          <li>
            <span class="num">0</span><sub>m</sub>
            <span class="gray">Total elevation</span>
          </li>
          <li>
            <span class="num">0</span><sub>km</sub>
            <span class="gray">Distance travelled</span>
          </li>
          <li>
            <span class="num">0</span><sub>h</sub>
            <span class="gray">Riding hours</span>
          </li>
        </ul>

        <div v-if="false" class="my-bikes-main__transfer">
          <div class="item disabled">
            <span class="d-flex">
             <span class="my-bikes-main__transfer--ic">
              <img alt="" src="/assets/images/transfer-and-rename/pin.svg">
            </span>
             <span class="my-bikes-main__transfer--text">
              <span class="title">Rides</span>
              <span class="text">Your rides on this bike</span>
            </span>
            </span>
          </div>
          <div class="item disabled">
            <span class="d-flex">
              <span class="my-bikes-main__transfer--ic">
              <img alt="" src="/assets/images/transfer-and-rename/location.svg">
            </span>
              <span class="my-bikes-main__transfer--text">
              <span class="title">Find my bike</span>
              <span class="text">Where's your bike?</span>
            </span>
            </span>
          </div>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/book.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Suspension guide</div>
                <div class="text">5 Easy Steps to Set Up Your Bike Suspension</div>
              </div>
            </div>
          </div>
          <div
            ref="transfer-no-bike"
            class="item large animation disabled"
            @click="startTransfer()"
          >
            <div v-if="transferNotStarted()" class="d-flex">
              <div v-if="pendingTransfer()" class="text-pending">Pending</div>
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/bike-bicycle.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title text-left">Transfer bike</div>
                <div class="text">Transfer of the bike and transfer of the bike to other users</div>
              </div>
            </div>
            <div v-if="isInitStatus()" class="d-flex">
              <button
                :disabled="true"
                class="btn btn-lg disabled"
              >
                Give a bike
              </button>
              <button
                :disabled="showTransferConfirmationAsSender()"
                class="btn btn-lg"
                @click.prevent="startTransferAsRecipient()"
              >
                Take a bike
              </button>
            </div>
            <div v-if="needPendingConfirm()" class="d-flex">
              <div class="title">
                You already have active transfer, do you want to abort it and start new?
              </div>
              <button class="btn w-110 mr-auto">Yes</button>
              <button class="btn w-110 ml-auto light">Cancel</button>
            </div>
            <div v-if="needEmailVerification()" class="d-flex">
              <div class="title">Email not confirmed</div>
              <div class="color-dark-gray">
                Please confirm your email<br> for bike transferring.<br> Resend confirmation link?
              </div>
              <button
                class="btn w-110 mr-auto"
                @click.prevent="sendLink()"
              >
                Yes
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelTransfer()"
              >
                Cancel
              </button>
            </div>
            <div v-if="linkSent()" class="d-flex">
              <div class="title">Link sent</div>
              <button
                class="btn w-100"
                @click.prevent="cancelTransfer()"
              >
                Close
              </button>
            </div>
            <div v-if="transferAsRecipientStarted()" class="d-flex">
              <div :class="codeWrapperClass()" class="code-wrap">
                <div class="input-wrap">
                  <input
                    :ref="`bike-code-input`"
                    class="code-input"
                    type="text"
                    @keyup="setTransferCode($event)">
                  <div class="code-show" @click.prevent="focusToCode()">
                    <span
                      v-for="number of [1, 2, 3, 4, 5, 6]"
                      :key="`code-part-bike-${number}`"
                    >
                      {{ getCodeSymbol(number) }}
                    </span>
                  </div>
                </div>
                <div v-if="!showCodeError()" class="color-dark-gray">Please enter the code</div>
                <div v-else class="color-dark-gray">Wrong code</div>
              </div>
              <button
                :class="confirmCodeBtnClass()"
                :disabled="confirmCodeDisabled()"
                class="btn w-110 mr-auto"
                @click.prevent="transferBikeToMe()"
              >
                Confirm
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelTransfer()"
              >
                Cancel
              </button>
            </div>
            <div v-if="codeAccepted()" class="d-flex">
              <div class="title">Code accepted</div>
              <div class="color-dark-gray">Wait for confirmation of the transfer by the previous owner</div>
              <button class="btn w-100" @click.prevent="cancelTransfer()">Close</button>
            </div>
          </div>
          <a class="item disabled" href="#">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/receipt.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">User manual</div>
                <div class="text">Сорок три Сорок три страницы</div>
              </div>
            </div>
          </a>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/messages.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">FAQ</div>
                <div class="text">Все что ты хотел знать о Forestal</div>
              </div>
            </div>
          </div>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/pen.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Rename bike</div>
                <div class="text">Кастом мечты твоей</div>
              </div>
            </div>
          </div>
          <div class="item disabled large">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/certificate.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Warranty agreement</div>
                <div class="text">
                  <div class="d-block">Сломалось - починим</div>
                  <div class="d-block">Сломал - чини сам</div>
                  <div class="d-block">Не упал - молодец</div>
                  <div class="d-block">Упал - лечись</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/lock.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Blocking</div>
                <div class="text">Заблокируй чтобы никто и ничего</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="bike in list"
        v-else
        :key="bike.id"
        :ref="`bike-${bike.id}`"
        class="my-bikes-main"
      >
        <div v-if="showTransferConfirmationAsSender(bike)" class="my-bikes-main__alert">
          <p class="my-bikes-main__alert--title">
            Are you sure you want to transfer this bike?
          </p>
          <button
            class="btn btn-gray"
            @click.prevent="completeTransfer(bike)"
          >
            Yes
          </button>
          <button
            class="btn btn-gray light"
            @click.prevent="cancelTransfer(bike, true)"
          >
            Cancel
          </button>
        </div>
        <div v-if="transferCanceled(bike)" class="my-bikes-main__alert">
          <p class="my-bikes-main__alert--title">Transfer cancelled</p>
          <button class="btn btn-gray w-100">Ok, I understand</button>
        </div>
        <div class="my-bikes-main__name">
          {{ bikeTitle(bike) }}
          <div v-if="pendingTransfer(bike)" class="text-pending">
            Pending <sup class="point">point</sup>
          </div>
        </div>
        <p v-if="bike.front['frame_number']" class="my-bikes-main__number">
          Frame number {{ bike.front['frame_number'] }}/999
        </p>
        <p class="my-bikes-main__des">
          {{ bike.front.description }}
        </p>
        <div class="my-bikes-main__img">
          <img :alt="bikeTitle(bike)" :src="bike.front.image">
        </div>
        <ul v-if="bike.stat" class="my-bikes-main__parameters">
          <li>
            <span class="num">
              {{ bike.stat.maxOverload }}
            </span><sub>G</sub>
            <span class="gray">Max G-force</span>
          </li>
          <li>
            <span class="num">
              {{ bike.stat.maxAirTime }}
            </span><sub>s</sub>
            <span class="gray">Max air time</span>
          </li>
          <li>
            <span class="num">
              {{ bike.stat.maxSpeed }}
            </span><sub>km/h</sub>
            <span class="gray">Max speed</span>
          </li>
          <li>
            <span class="num">
              {{ bike.stat.totalElevation }}
            </span><sub>m</sub>
            <span class="gray">Total elevation</span>
          </li>
          <li>
            <span class="num">
              {{ bike.stat.distance }}
            </span><sub>km</sub>
            <span class="gray">Distance travelled</span>
          </li>
          <li>
            <span class="num">
              {{ bike.stat.time }}
            </span><sub>h</sub>
            <span class="gray">Riding hours</span>
          </li>
        </ul>
        <div class="my-bikes-main__transfer">
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/pin.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Rides</div>
                <div class="text">Your rides on this bike</div>
              </div>
            </div>
          </div>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/location.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Find my bike</div>
                <div class="text">Where is your bike?</div>
              </div>
            </div>
          </div>
          <a
            :class="{disabled: !bikeSuspension(bike)}"
            :href="bikeSuspension(bike)"
            class="item"
            target="_blank"
          >
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/book.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Suspension guide</div>
                <div class="text">5 Steps to Set Up Your Bike Suspension</div>
              </div>
            </div>
          </a>
          <div :ref="`transfer-${bike.id}`" class="item large animation disabled" @click="startTransfer(bike)">
            <div v-if="transferNotStarted(bike)" class="d-flex">
              <div v-if="pendingTransfer(bike)" class="text-pending">Pending</div>
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/bike-bicycle.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title text-left">Transfer bike</div>
                <div class="text">Transfer of the bike</div>
              </div>
            </div>
            <div v-if="isInitStatus(bike)" class="d-flex">
              <button
                :disabled="showTransferConfirmationAsSender(bike)"
                class="btn btn-lg"
                @click.prevent="startTransferAsSender(bike)"
              >
                Give a bike
              </button>
              <button
                :disabled="showTransferConfirmationAsSender(bike)"
                class="btn btn-lg"
                @click.prevent="startTransferAsRecipient(bike)"
              >
                Take a bike
              </button>
            </div>
            <div v-if="needPendingConfirm(bike)" class="d-flex">
              <div class="title">
                You already have active transfer, do you want to abort it and start new?
              </div>
              <button
                class="btn w-110 mr-auto"
                @click.prevent="showConfirmationAsSender(bike, true)"
              >
                Yes
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelTransfer(bike)"
              >
                Cancel
              </button>
            </div>
            <div v-if="needEmailVerification(bike)" class="d-flex">
              <div class="title">Email not confirmed</div>
              <div class="color-dark-gray">Please confirm your email<br> for bike transferring.<br> Resend confirmation
                link?
              </div>
              <button
                class="btn w-110 mr-auto"
                @click.prevent="sendLink(bike)"
              >
                Yes
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelTransfer(bike)"
              >
                Cancel
              </button>
            </div>
            <div v-if="linkSent(bike)" class="d-flex">
              <div class="title">Link sent</div>
              <button class="btn w-100" @click.prevent="cancelTransfer(bike)">Close</button>
            </div>
            <div v-if="transferAsSenderStarted(bike)" class="d-flex">
              <div class="text">The new owner of the bike must enter the code in
                <span
                  :ref="`transfer-time-${bike.id}`"
                  :data-expired="transferExpired(bike)"
                >
                  <span :ref="`transfer-code-${bike.id}`">
                    {{ transferExpired(bike) }}
                  </span>
                </span> seconds:
              </div>
              <div class="number">
                <div class="transfer-code">
                  {{ transferCode(bike) }}
                </div>
              </div>
              <div class="color-dark-gray text-left mb-2">Or scan the code:</div>
              <qriously :size="70" :value="transferCode(bike, false)" class="qr-code"/>
              <div class="color-dark-gray text-left mb-2">After that you will receive a letter with a link to confirm
                the transfer of the bike.
              </div>
              <button class="link mr-auto" type="button" @click.prevent="goToContactPage">or contact us</button>
              <button class="link ml-auto" type="button" @click.prevent="cancelTransfer(bike)">close</button>
            </div>
            <div v-if="transferAsRecipientStarted(bike)" class="d-flex">
              <div :class="codeWrapperClass(bike)" class="code-wrap">
                <div class="input-wrap">
                  <input
                    :ref="`bike-${bike.id}-code-input`"
                    class="code-input"
                    type="text"
                    @keyup="setTransferCode($event, bike)">
                  <div class="code-show" @click.prevent="focusToCode(bike)">
                    <span
                      v-for="number of [1, 2, 3, 4, 5, 6]"
                      :key="`code-part-bike-${bike.id}-${number}`"
                    >
                      {{ getCodeSymbol(number, bike) }}
                    </span>
                  </div>
                </div>
                <div v-if="!showCodeError(bike)" class="color-dark-gray">Please enter the code</div>
                <div v-else class="color-dark-gray">Wrong code</div>
              </div>
              <button
                :class="confirmCodeBtnClass(bike)"
                :disabled="confirmCodeDisabled(bike)"
                class="btn w-110 mr-auto"
                @click.prevent="transferBikeToMe(bike)"
              >
                Confirm
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelTransfer(bike)"
              >
                Cancel
              </button>
            </div>
            <div v-if="codeAccepted(bike)" class="d-flex">
              <div class="title">Code accepted</div>
              <div class="color-dark-gray">Wait for confirmation of the transfer by the previous owner</div>
              <button class="btn w-100" @click.prevent="cancelTransfer(bike)">Close</button>
            </div>
          </div>
          <a
            :class="{disabled: !bikeManual(bike)}"
            :href="bikeManual(bike)"
            class="item"
            target="_blank"
          >
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/receipt.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">User manual</div>
                <div class="text">Bike manual</div>
              </div>
            </div>
          </a>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/messages.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">FAQ</div>
                <div class="text">Everything you wanted to know about Forestal</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div
              v-if="renamingNotStarted(bike)"
              class="d-flex"
              @click.prevent="startRenameBike(bike)"
            >
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/pen.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Rename bike</div>
                <div class="text">
                  {{ currentBikeTitle(bike) }}
                </div>
              </div>
            </div>
            <div v-if="renamingStarted(bike)" class="d-flex">
              <div :class="{fill: fills}" class="name-wrap">
                <input
                  id="new_name"
                  :value="renamingTitle(bike)"
                  class="name-wrap"
                  type="text"
                  @input="changeNameForBike($event, bike)"
                >
              </div>
              <div v-if="renamingHasError(bike)" class="text-error">
                {{ renamingErrorText(bike) }}
              </div>
              <button
                :disabled="renamingHasError(bike) || renamingTitle(bike).length === 0"
                class="btn w-110 mr-auto"
                @click.prevent="saveNewBikeName(bike)"
              >
                Save
              </button>
              <button
                class="btn w-110 ml-auto light"
                @click.prevent="cancelRenaming(bike)"
              >
                Cancel
              </button>
            </div>
            <div v-if="renamingCompleted(bike)" class="d-flex">
              <div class="title saved">Saved!</div>
            </div>
          </div>
          <a class="item large" href="/en/page/warranty" target="_blank">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/certificate.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Warranty agreement</div>
                <div class="text">
                  <span class="d-block">Broken - fix it</span>
<!--                  <span class="d-block">Broke - fix it yourself</span>-->
<!--                  <span class="d-block">Didn't fall - well done</span>-->
<!--                  <span class="d-block">Fell - get well</span>-->
                </div>
              </div>
            </div>
          </a>
          <div class="item disabled">
            <div class="d-flex">
              <div class="my-bikes-main__transfer--ic">
                <img alt="" src="/assets/images/transfer-and-rename/lock.svg">
              </div>
              <div class="my-bikes-main__transfer--text">
                <div class="title">Blocking</div>
                <div class="text">Block the bike</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-bikes-app">
        <p class="my-bikes-app__title">For link new bike please go to mobile application:</p>
        <div class="nav-store-wrap">
          <a class="appStore" href="#" target="_blank">
            <img alt="app-store" src="/assets/images/app_store2.svg">
          </a>
          <a class="googlePlay" href="#" target="_blank">
            <img alt="google-play" src="/assets/images/google-play2.svg">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: ['trans', 'lang', 'transfered'],
  computed: {
    ...mapGetters({
      list: 'bikes/list'
    })
  },
  data() {
    return {
      transfer: {},
      renaming: {},
      nameSearch: '',
      fills: false,
      noBikeTransfer: {},
      completedMessage: false
    }
  },
  timers: {
    refreshCode: {time: 1000, autostart: true, repeat: true}
  },
  mounted() {
    this.loadBikes();
  },
  methods: {
    bikeManual(bike) {
      if (bike.front.model && bike.front.model['manual']) {
        return bike.front.model['manual'];
      }
      return null
    },
    bikeSuspension(bike) {
      if (bike.front.model && bike.front.model['suspension']) {
        return bike.front.model['suspension'];
      }
      return null
    },
    focusToCode(bike = null) {
      if (!bike) {
        this.$refs['bike-code-input'].focus()
      } else {
        this.$refs[`bike-${bike.id}-code-input`][0].focus()
      }
    },
    currentBikeTitle(bike) {
      if (bike.front['custom_title']) {
        return bike.front['custom_title']
      } else {
        return bike.front['title']
      }
    },
    renamingStatus(bike) {
      if (!this.renaming[bike.id] || !this.renaming[bike.id].status) {
        return 'init'
      }

      return this.renaming[bike.id].status
    },
    renamingNotStarted(bike) {
      return this.renamingStatus(bike) === 'init'
    },
    renamingStarted(bike) {
      return this.renamingStatus(bike) === 'started'
    },
    renamingCompleted(bike) {
      return this.renamingStatus(bike) === 'completed'
    },
    startRenameBike(bike) {
      let renaming = {...this.renaming}
      if (!renaming[bike.id] || !renaming[bike.id].status) {
        renaming[bike.id] = {
          status: 'started'
        }
      }
      this.$set(this.$data, 'renaming', renaming)
    },
    changeNameForBike(event, bike) {
      let renaming = {...this.renaming[bike.id]}
      renaming.error = null
      this.$set(this.renaming, bike.id, renaming)
      renaming.title = event.target.value

      if (renaming.title.length > 11) {
        renaming.error = '11 symbols max'
      }

      this.$set(this.renaming, bike.id, renaming)
    },
    renamingHasError(bike) {
      let renaming = this.renaming[bike.id]
      return renaming && renaming.error
    },
    renamingErrorText(bike) {
      let renaming = this.renaming[bike.id]
      return renaming.error
    },
    saveNewBikeName(bike) {
      if (this.renaming[bike.id] && this.renaming[bike.id].title) {
        let renaming = {...this.renaming[bike.id]}
        let newTitle = this.renaming[bike.id].title.substring(0, 11);
        this.$store.dispatch('bikes/rename', {
          bikeID: bike.id,
          name: newTitle,
          path: this.$path
        }).then((result) => {
          if (result['status_code'] === 0) {
            renaming.status = 'completed'
            renaming.error = null
          }
          this.$set(this.renaming, bike.id, renaming)
          this.updateBikeNameInStore(bike, newTitle)
          setTimeout(() => {
            this.$set(this.renaming, bike.id, {})
          }, 4000)
        }).catch(error => {
          console.dir(error)
          renaming.error = "Some error, while update bike name. try later"
          this.$set(this.renaming, bike.id, renaming)
        })
      }
    },
    updateBikeNameInStore(bike, name) {
      this.$store.commit('bikes/updateList', {bike, name})
    },
    cancelRenaming(bike) {
      this.$set(this.renaming, bike.id, {})
    },
    renamingTitle(bike) {
      if (this.renaming[bike.id]) {
        return this.renaming[bike.id].title ? this.renaming[bike.id].title : ''
      }
      return ''
    },
    refreshCode() {
      for (let key of Object.keys(this.transfer)) {
        let timeElementArray = this.$refs[`transfer-time-${key}`]
        if (timeElementArray && timeElementArray[0]) {
          let timeElement = timeElementArray[0]
          let time = timeElement.getAttribute('data-expired')
          let newTime = time - 1
          if (newTime >= 0) {
            timeElement.setAttribute('data-expired', newTime)
            timeElement.innerText = newTime
          } else {
            timeElement.setAttribute('data-expired', 0)
            timeElement.innerText = 0
            this.$store.dispatch('bikes/loadTransfer', {
              bike_id: key,
              path: this.$path
            }).then(result => {
              let transfer = result.data.transfer
              let expired = Math.ceil(transfer['expired_at'] - this.$moment.now() / 1000)
              if (expired <= 0) {
                expired = 0
              }
              timeElement.setAttribute('data-expired', expired)
              timeElement.innerText = expired
              let data = {...this.transfer[key]}
              data.status = 'as-sender-started'
              data.showConfirmationAsSender = false
              data.info = {...transfer}
              this.$set(this.transfer, key, data)
            }).catch(error => {
              if (error.response && error.response.status === 404) {
                let data = {...this.transfer[key]}
                data.status = 'start'
                data.showConfirmationAsSender = false
                data.interval = null
                data.info = null
                this.$set(this.transfer, key, data)
              }
            })
          }
        }
      }
    },
    getCompletedTransfer() {
      let transfer = null;
      for (let key of Object.keys(this.transfer)) {
        if (this.transfer[key] && this.transfer[key].completed) {
          transfer = key
          break;
        }
      }
      return transfer
    },
    hasCompletedTransfer() {
      return this.completedMessage
    },
    deleteTransfer() {
      let transferID = this.getCompletedTransfer();
      this.$store.dispatch('bikes/deleteTransfer', {
        bike_id: transferID,
        path: this.$path
      }).then(() => {
        let transfer = {...this.transfer[transferID]}
        transfer.completed = false
        this.$set(this.transfer, transferID, transfer)
      })
    },
    symbolDisabled(index, bike) {
      if (bike) {
        let transfer = {...this.transfer[bike.id]}
        if (!transfer.code) {
          transfer.code = ['-', '-', '-', '-', '-', '-']
        }
        if (index === 1) {
          return transfer.code[index] === '' || transfer.code[index] !== '-'
        } else {
          if (index === 6) {
            return transfer.code[index - 2] === '-'
              || transfer.code[index - 2] === '';
          } else {
            return transfer.code[index - 2] === '-'
              || transfer.code[index - 2] === ''
              || (transfer.code[index] === '' || transfer.code[index] !== '-');
          }
        }
      }

      return true
    },
    focusCodeSymbol(bike = null) {
      if (bike) {
        let transfer = {...this.transfer[bike.id]}
        if (!transfer.code) {
          transfer.code = ['-', '-', '-', '-', '-', '-']
        }
        if (transfer.code[0] === '-') {
          transfer.code[0] = ''
        }
      }
    },
    blurCodeSymbol(event, index, bike = null) {
      if (bike) {
        let transfer = this.transfer[bike.id]
        if (!transfer.code) {
          transfer.code = ['-', '-', '-', '-', '-', '-']
        }
        let symbol
        if (event.target.value !== '-' && event.target.value !== '') {
          symbol = event.target.value.charAt(0)
        } else {
          symbol = '-'
        }
        transfer.code[index - 1] = symbol

        this.$set(this.transfer, bike.id, transfer)
      }
    },
    getCodeSymbol(index, bike = null) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
      } else {
        transfer = {...this.noBikeTransfer}
      }

      if (!transfer.code) {
        transfer.code = ['-', '-', '-', '-', '-', '-']
      }
      return transfer.code[index - 1]
    },
    confirmCodeDisabled(bike = null) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
      } else {
        transfer = {...this.noBikeTransfer}
      }

      if (!transfer.code) {
        transfer.code = ['-', '-', '-', '-', '-', '-']
        if (bike) {
          this.$set(this.transfer, bike.id, transfer)
        } else {
          this.$set(this.$data, 'noBikeTransfer', transfer)
        }
      }

      return transfer.code.includes('-')
    },
    transferBikeToMe(bike = null) {
      let code
      let transfer
      let ref
      if (bike) {
        code = this.transfer[bike.id].code.join('')
        transfer = {...this.transfer[bike.id]}
        ref = `bike-${bike.id}-code-input`
      } else {
        code = this.noBikeTransfer.code.join('')
        transfer = {...this.noBikeTransfer}
        ref = `bike-code-input`
      }

      this.$store.dispatch('bikes/transferAsRecipient', {code: code, path: this.$path})
        .then((result) => {
          transfer.codeError = !result.status;
          if (!transfer.codeError) {
            transfer.status = 'code-accepted'
          }
          if (bike) {
            this.$set(this.transfer, bike.id, transfer)
            this.$refs[ref][0].focus()
          } else {
            this.$set(this.$data, 'noBikeTransfer', transfer)
            this.$refs[ref].focus()
          }
        })
    },
    confirmCodeBtnClass(bike) {
      return {
        disabled: this.confirmCodeDisabled(bike)
      }
    },
    goToContactPage() {
      location.href = `/${this.lang}/contact`
    },
    transferStatus(bike = null) {
      if (bike) {
        if (this.transfer[bike.id]) {
          return this.transfer[bike.id].status
        }
        return null
      }

      return this.noBikeTransfer.status
    },
    isInitStatus(bike = null) {
      return this.transferStatus(bike) === 'init'
    },
    needEmailVerification(bike) {
      return this.transferStatus(bike) === 'need-email-verification'
    },
    needPendingConfirm(bike) {
      return this.transferStatus(bike) === 'pending'
    },
    linkSent(bike) {
      return this.transferStatus(bike) === 'link-sent'
    },
    transferAsSenderStarted(bike) {
      return this.transferStatus(bike) === 'as-sender-started'
    },
    transferAsRecipientStarted(bike = null) {
      return this.transferStatus(bike) === 'as-recipient-started'
    },
    codeAccepted(bike = null) {
      return this.transferStatus(bike) === 'code-accepted'
    },
    showCodeError(bike = null) {
      if (bike) {
        return this.transfer[bike.id].codeError
      }
      return this.noBikeTransfer.codeError;
    },
    codeWrapperClass(bike = null) {
      if (bike) {
        return {
          error: this.showCodeError(bike)
        }
      }
      return {
        error: this.showCodeError()
      }
    },
    transferNotStarted(bike = null) {
      if (bike) {
        return this.transferStatus(bike) === null
          || this.transferStatus(bike) === undefined
          || this.transferStatus(bike) === 'start'
      }

      return this.transferStatus() === null
        || this.transferStatus() === undefined
        || this.transferStatus() === 'start'
    },
    pendingTransfer(bike = null) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
      } else {
        transfer = {...this.noBikeTransfer}
      }
      return transfer ? transfer.pending : false
    },
    transferCanceled(bike = null) {
      let transfer
      if (bike) {
        transfer = this.transfer[bike.id]
      } else {
        transfer = this.noBikeTransfer
      }
      return transfer ? transfer.canceled : false
    },
    setTransferCode(event, bike = null) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
      } else {
        transfer = {...this.noBikeTransfer}
      }
      if (!transfer.code) {
        transfer.code = ['-', '-', '-', '-', '-', '-']
      }
      let symbols = event.target.value.replace(/\D/g, "")
      let symbolsArray = symbols.split('')
      let symbolLength = symbols.length
      if (symbolLength < 6) {
        for (let i = 0; i < 6 - symbolLength; i++) {
          symbolsArray.push('-')
        }
      }
      let idx = 0;
      for (let symbol of symbolsArray) {
        if (idx > transfer.code.length - 1) {
          break;
        }
        transfer.code[idx] = symbol
        idx++
      }
      transfer.codeError = false
      if (bike) {
        this.$refs[`bike-${bike.id}-code-input`][0].value = symbols.substring(0, 6)
        this.$set(this.transfer, bike.id, transfer)
      } else {
        this.$refs[`bike-code-input`].value = symbols.substring(0, 6)
        this.$set(this.$data, 'noBikeTransfer', transfer)
      }
    },
    startTransfer(bike = null) {
      console.log('Transfer disabled')
      return
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
      } else {
        transfer = {...this.noBikeTransfer}
      }
      if (!transfer || !transfer.status) {
        if (bike) {
          if (!transfer) {
            this.$set(this.transfer, bike.id, {
              status: 'init'
            })
          } else {
            transfer.status = 'init'
            this.$set(this.transfer, bike.id, transfer)
          }
        } else {
          if (!transfer) {
            this.$set(this.$data, 'noBikeTransfer', {
              status: 'init'
            })
          } else {
            transfer.status = 'init'
            this.$set(this.$data, 'noBikeTransfer', transfer)
          }
        }
      }
    },
    showTransferConfirmationAsSender(bike = null) {
      if (bike) {
        return this.transfer[bike.id] && this.transfer[bike.id].pending && this.list.length > 0 && bike.id === parseInt(this.transfered)
      }

      return false
    },
    showConfirmationAsSender(bike = null, asNew = false) {
      if (bike) {
        let transfer = {...this.transfer[bike.id]}
        if (transfer.pending && !asNew) {
          transfer.status = 'pending'
        } else {
          transfer.showConfirmationAsSender = true
          transfer.asNew = asNew
        }
        this.$set(this.transfer, bike.id, transfer)
        let bikeCard = this.$refs[`bike-${bike.id}`][0]
        if ((bikeCard && transfer.status !== 'pending') || (bikeCard && asNew)) {
          this.doScrolling(bikeCard.getBoundingClientRect().top + window.scrollY - 100, 500)
        }
      } else {
        let transfer = this.noBikeTransfer
        if (transfer.pending && !asNew) {
          transfer.status = 'pending'
        } else {
          transfer.showConfirmationAsSender = true
          transfer.asNew = asNew
        }
        this.$set(this.$data, 'noBikeTransfer', transfer)
        let bikeCard = this.$refs['transfer-no-bike'][0]
        if ((bikeCard && transfer.status !== 'pending') || (bikeCard && asNew)) {
          this.doScrolling(bikeCard.getBoundingClientRect().top + window.scrollY - 100, 500)
        }
      }
    },
    doScrolling(elementY, duration) {
      let startingY = window.pageYOffset;
      let diff = elementY - startingY;
      let start;

      window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        let time = timestamp - start;
        let percent = Math.min(time / duration, 1);

        window.scrollTo(0, startingY + diff * percent);
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      })
    },
    startTransferAsSender(bike) {
      let transfer = {...this.transfer[bike.id]}
      transfer.status = 'as-sender-started'
      transfer.showConfirmationAsSender = false

      this.$store.dispatch('bikes/transferAsSender', {
        bike_id: bike.id,
        as_new: transfer.asNew || false,
        path: this.$path
      }).then(result => {
        transfer.info = result.data.transfer
        this.$set(this.transfer, bike.id, transfer)
      })
    },
    startTransferAsRecipient(bike = null) {
      if (bike) {
        let transfer = {...this.transfer[bike.id]}
        transfer.status = 'as-recipient-started'
        this.$set(this.transfer, bike.id, transfer)
        setTimeout(() => {
          this.$refs[`bike-${bike.id}-code-input`][0].focus()
        }, 50)
      } else {
        let user = this.$store.getters['getAuthUser']
        let transfer = {...this.noBikeTransfer}
        if (!user.email_verified_at) {
          transfer.status = 'need-email-verification'
        } else {
          transfer.status = 'as-recipient-started'
        }
        this.$set(this.$data, 'noBikeTransfer', transfer)
        setTimeout(() => {
          this.$refs['bike-code-input'].focus()
        }, 50)
      }
    },
    completeTransfer(bike = null) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
        if (transfer.pending) {
          this.$store.dispatch('bikes/completeTransfer', {bike_id: bike.id, path: this.$path}).then((result) => {
            if (result['status_code'] === 0) {
              transfer = null;
              this.$set(this.transfer, bike.id, {...transfer})
              this.$store.commit('bikes/removeBikeFromList', bike.id)
              this.showCompletedMessage()
            } else {
              console.log(result.data.message)
            }
          }).catch(error => {
            console.log(error)
          })
        }
      }
    },
    showCompletedMessage() {
      this.completedMessage = true
    },
    hideCompletedMessage() {
      this.completedMessage = false
    },
    cancelTransfer(bike = null, dispatch = false, onlyStarted = false) {
      let transfer
      if (bike) {
        transfer = {...this.transfer[bike.id]}
        if (transfer.status === 'pending' && !dispatch) {
          transfer.status = 'start'
          transfer.asNew = false
          this.$set(this.transfer, bike.id, transfer)
          setTimeout(() => {
            transfer.status = null
            this.$set(this.transfer, bike.id, transfer)
          }, 1)
        } else {
          setTimeout(() => {
            transfer = null
            this.$set(this.transfer, bike.id, transfer)
            this.$store.dispatch(
              'bikes/cancelTransfer',
              {bike_id: bike.id, path: this.$path, dispatch, only_started: onlyStarted}
            )
          }, 1)
        }
      } else {
        transfer = {...this.noBikeTransfer}
        if (transfer.status === 'pending') {
          transfer.status = 'start'
          transfer.asNew = false
          setTimeout(() => {
            transfer.status = null
            this.$set(this.transfer, bike.id, transfer)
          }, 1)
        } else {
          transfer = null
        }
        this.$set(this.$data, 'noBikeTransfer', transfer)
      }
    },
    sendLink(bike = null) {
      this.$store.dispatch('ResendVerificationLink', {
        path: this.$path
      }).then(() => {
        let transfer
        if (bike) {
          transfer = {...this.transfer[bike.id]}
          transfer.status = 'link-sent'
          this.$set(this.transfer, bike.id, transfer)
        } else {
          transfer = {...this.noBikeTransfer}
          transfer.status = 'link-sent'
          this.$set(this.$data, 'noBikeTransfer', transfer)
        }
      })
    },
    bikeTitle(bike) {
      let title = bike.front.title;
      if (bike.front['custom_title']) {
        title += ' - ' + bike.front['custom_title']
      }
      return title
    },
    loadBikes() {
      this.$store.dispatch('bikes/load', {path: this.$path}).then(() => {
        this.loadTransfers()
        this.loadRidesInfo()
        for (let bike of this.list) {
          this.cancelTransfer(bike, true, true)
        }
      })
    },
    loadTransfers() {
      this.$store.dispatch('bikes/loadTransfers', {
        path: this.$path
      }).then((result) => {
        let transferAsSender = result.data['transfer_as_sender']
        let transferAsRecipient = result.data['transfer_as_recipient']
        for (let tr of transferAsSender) {
          let transfer = this.transfer[tr.bike_id]
          if (!transfer) {
            transfer = {
              pending: tr.status === 'pending',
              completed: tr.status === 'completed',
              canceled: tr.status === 'canceled',
            }
          } else {
            transfer.pending = tr.status === 'pending'
            transfer.completed = tr.status === 'completed'
            transfer.canceled = tr.status === 'canceled'
          }

          this.$set(this.transfer, tr.bike_id, transfer)
        }
        for (let tr of transferAsRecipient) {
          let transfer = {...this.noBikeTransfer}
          if (!transfer) {
            transfer = {
              pending: tr.status === 'pending',
              completed: tr.status === 'completed',
              canceled: tr.status === 'canceled',
            }
          } else {
            transfer.pending = tr.status === 'pending'
            transfer.completed = tr.status === 'completed'
            transfer.canceled = tr.status === 'canceled'
          }
          this.$set(this.$data, 'noBikeTransfer', transfer)
        }
      })
    },
    loadRidesInfo() {
      this.$store.dispatch('bikes/ridesStatistics', {
        bikes: this.list.map(item => {
          return item.id
        })
      })
    },
    transferCode(bike, withSpace = true) {
      if (!this.transfer[bike.id].info) {
        return null
      }
      let code = this.transfer[bike.id].info.code;
      if (!withSpace) {
        return code
      }
      let middle = Math.ceil(code.length / 2);
      let s1 = code.slice(0, middle);
      let s2 = code.slice(middle);
      return s1 + ' ' + s2
    },
    transferExpired(bike) {
      let transfer = {...this.transfer[bike.id]}
      let expired
      if (!transfer.info) {
        expired = 120
      } else {
        expired = transfer.info['expired_at'] - this.$moment.now() / 1000
      }
      expired = Math.ceil(expired)
      if (expired <= 0) {
        expired = 0
      }
      return expired
    },
    inputFill() {
      this.fills = !this.nameSearch === '';
    }
  }
}
</script>

<style lang="scss">
.my-bikes {
  margin-left: 130px;

  .w-100 {
    width: 100%;
  }

  .mb-32 {
    margin-bottom: 32px !important;
  }

  .text-center {
    text-align: center !important;
  }

  .text-pending {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    align-items: center;
    color: #2B99FF;
    padding: 0 12px;
    height: 22px;
    border: 1px solid #2B99FF;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    justify-content: center;

    .point {
      width: 6px;
      height: 6px;
      font-size: 0;
      border-radius: 100%;
      background-color: #2B99FF;
      margin-top: -6px;
      margin-left: 4px;
    }
  }

  .my-bikes-wrapper {

    display: block;
    @media (min-width: 1200px) {
      width: calc(100% + 80px);
      margin-left: -40px;
    }
  }

  .my-bikes-heading {
    margin-bottom: 32px;

    p:last-child {
      margin-bottom: 0;
    }

    @media (min-width: 1200px) {
      padding-left: 40px;
    }
  }

  .my-bikes-alert {
    display: flex;
    flex-wrap: wrap;
    background-color: #F8F8F8;
    padding: 20px;
    box-shadow: 0 4px 4px rgba(205, 205, 205, 0.25);
    border-radius: 14px;
    margin-bottom: 32px;
    justify-content: space-between;

    &__title {
      font-weight: bold;
      font-size: 25px;
      line-height: 32px;
      margin: 0 0 20px;
      width: 100%;
      color: #1C1C1C;
      text-align: center;
    }

    .btn {
      width: calc(50% - 20px);
      color: #1C1C1C;
      font-size: 17px;
      line-height: 18px;

      &.btn-gray {
        background-color: #fff;
        height: 54px;

        &:hover {
          background-color: #cff800;
        }

        &.disabled {
          &:hover {
            background-color: #fff;
          }
        }
      }

      &.w-100 {
        width: 100%;
      }

      &.light {
        font-weight: normal;
      }
    }
  }

  .my-bikes-main {
    background: #F8F8F8;
    border-radius: 14px;
    padding: 24px 40px 40px;
    margin-bottom: 32px;

    .my-bikes-main__alert {
      display: flex;
      flex-wrap: wrap;
      background-color: #fff;
      padding: 20px;
      box-shadow: 0 4px 4px rgba(205, 205, 205, 0.25);
      border-radius: 14px;
      margin-bottom: 32px;
      justify-content: space-between;

      &--title {
        font-weight: bold;
        font-size: 25px;
        line-height: 32px;
        margin: 0 0 20px;
        width: 100%;
        color: #1C1C1C;
        text-align: center;
      }

      .btn {
        width: calc(50% - 20px);
        color: #1C1C1C;
        font-size: 17px;
        line-height: 18px;

        &.w-100 {
          width: 100%;
        }

        &.light {
          font-weight: normal;
        }
      }
    }

    .my-bikes-main__name {
      font-weight: 500;
      font-size: 25px;
      line-height: 38px;
      margin: 0 0 4px;
      color: #1C1C1C;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .text-pending {
        margin-left: 16px;
      }
    }

    .my-bikes-main__number {
      font-weight: 500;
      font-size: 17px;
      line-height: 25px;
      margin: 0 0 4px;
      color: #1C1C1C;
      width: 100%;
      display: block;
    }

    .my-bikes-main__des {
      font-size: 17px;
      line-height: 25px;
      margin: 0 0 4px;
      color: #6D6D6D;
      width: 100%;
      display: block;
    }

    .my-bikes-main__img {
      margin: 32px 0 32px;
      width: 100%;
      display: block;

      img {
        width: 100%;
        mix-blend-mode: darken;
      }
    }

    .my-bikes-main__parameters {
      display: grid;
      grid-gap: 32px 0;
      width: 100%;
      grid-template-columns: repeat(3, 1fr);
      margin-bottom: 64px;

      &:last-child {
        margin-bottom: 0;
      }

      li {
        font-weight: bold;
        font-size: 40px;
        line-height: 41px;
        color: #333333;
        display: block;
        border-right: 1px solid #ccc;
        padding: 4px 30px;
        @media (min-width: 576px) {
          &:nth-child(3n + 3) {
            border: none;
          }
        }
        @media (max-width: 575px) {
          &:nth-child(2n + 2) {
            border: none;
          }
        }

        .sub, sub {
          font-weight: normal;
          font-size: 20px;
          line-height: 20px;
          color: #9B9B9B;
        }

        .gray {
          font-weight: normal;
          font-size: 14px;
          line-height: 14px;
          color: #B9B9B9;
          display: block;
          margin: 6px 0 0;
        }
      }
    }

    .my-bikes-main__transfer {
      width: 100%;

      &:after {
        content: '';
        clear: both;
        display: block;
      }

      a.item:not(.disabled):hover,
      .item.animation:not(.disabled):hover {
        transform: scale(1.02);
      }

      .item {
        padding: 20px 30px;
        background: #FFFFFF;
        box-shadow: 0 4px 4px rgba(205, 205, 205, 0.25);
        border-radius: 14px;
        display: flex;
        align-items: center;
        text-decoration: none;
        width: calc(50% - 15px);
        margin-bottom: 24px;
        transform: scale(1);
        transition: all .2s linear;
        color: #1C1C1C;

        &.animation {
          cursor: pointer;
        }

        &.disabled {
          cursor: auto !important;

          .my-bikes-main__transfer--ic,
          .my-bikes-main__transfer--text {
            opacity: 0.2;
          }
        }

        &.large {
          height: 268px;

          .title {
            font-weight: bold;
            font-size: 25px;
            line-height: 32px;
            text-align: center;
            margin-bottom: 20px;
            color: #1C1C1C;
            width: 100%;

            &:last-child {
              margin-bottom: 0;
            }
          }

          .text {
            color: #1C1C1C;
            width: 100%;
            display: block;
            margin-bottom: 8px;
          }

          .number {
            font-weight: 500;
            font-size: 17px;
            line-height: 1;
            letter-spacing: 4px;
            width: 100%;
            display: block;
            margin-bottom: 8px;
          }

          .qr-code {
            width: 68px;
            height: 68px;
            margin-bottom: 8px;
            object-fit: contain;
          }

          .color-dark-gray {
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            margin-bottom: 20px;
            width: 100%;

            &:last-child {
              margin-bottom: 0;
            }
          }

          .link {
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            color: #1C1C1C;
            border: none;
            box-shadow: none;
            outline: none;
          }

          .code-wrap {
            background: #F8F8F8;
            border-radius: 14px;
            margin-bottom: 35px;
            padding: 24px 16px;
            text-align: center;
            display: block;
            width: 100%;

            &.error {
              background: #FFF7F7;

              .code-show {
                span {
                  color: #FF2B2B;
                }
              }

              .color-dark-gray {
                color: #FF2B2B !important;
              }
            }

            .input-wrap {
              display: inline-flex;
              justify-content: center;
              position: relative;
              margin-bottom: 10px;

              .code-input {
                color: transparent;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                user-select: none;
                cursor: pointer;
                pointer-events: none;

                &::-moz-selection {
                  color: transparent;
                  background: transparent;
                }

                &::selection {
                  color: transparent;
                  background: transparent;
                }

                &:focus ~ .code-show {
                  color: #000;
                }
              }

              .code-show {
                font-weight: bold;
                font-size: 25px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 4px;
                color: #1C1C1C;
                display: flex;
                align-items: center;

                span {
                  width: 20px;
                  text-align: center;

                  &:nth-child(3) {
                    margin-right: 4px;
                  }

                  &:nth-child(4) {
                    margin-left: 4px;
                  }
                }
              }
            }

            input {
              background: transparent;
              border-radius: 0;
              display: block;
              font-weight: 500;
              font-size: 25px;
              line-height: 26px;
              letter-spacing: 4px;
              box-sizing: border-box;
              margin-bottom: 10px;
              border: none;
              height: 36px;
              width: 20px;
              padding: 0;
              margin-left: 0;
              margin-right: 0;
              text-align: center;

              &:nth-child(3) {
                margin-right: 4px;
              }

              &:nth-child(4) {
                margin-left: 4px;
              }
            }

            .color-dark-gray {
              display: block;
              width: 100%;
            }
          }

          .text-pending {
            position: absolute;
            top: 12px;
            right: 12px;
          }

          .my-bikes-main__transfer--ic {
            width: 100%;
            height: auto;
            margin-bottom: 18px;

            img {
              width: auto;
              height: auto;
              max-width: 100%;
            }
          }

          .my-bikes-main__transfer--text {
            width: 100%;
            padding: 0;
          }
        }

        .text-left {
          text-align: left !important;
        }

        .text-center {
          text-align: center !important;
        }

        .d-flex {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;
        }

        .my-bikes-main__transfer--ic {
          width: 48px;
          height: 55px;

          img {
            width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }

        .my-bikes-main__transfer--text {
          width: calc(100% - 48px);
          padding-left: 30px;
          display: block;

          .title {
            font-weight: bold;
            font-size: 17px;
            line-height: 18px;
            margin: 0 0 8px;
            color: #1C1C1C;
            display: block;
            text-align: left;
          }

          .text {
            font-size: 12px;
            line-height: 16px;
            margin: 0 0 0;
            color: #686868;
            display: block;
          }
        }

        .name-wrap {
          width: 100%;
          margin-bottom: 8px;
          position: relative;

          &.fill {
            label {
              display: none;
            }
          }

          input {
            height: 42px;
            background: #F8F8F8;
            border-radius: 14px;
            border: none;
            text-align: center;
            padding: 4px 24px;
            color: #1C1C1C;
            font-weight: bold;
            font-size: 25px;
            line-height: 1;
            margin: 0;

            &::-webkit-input-placeholder {
              color: #686868;
              font-weight: normal;
              font-size: 12px;
              line-height: 1;
            }

            &::-moz-placeholder {
              color: #686868;
              font-weight: normal;
              font-size: 12px;
              line-height: 1;
            }

            &:-moz-placeholder {
              color: #686868;
              font-weight: normal;
              font-size: 12px;
              line-height: 1;
            }

            &:-ms-input-placeholder {
              color: #686868;
              font-weight: normal;
              font-size: 12px;
              line-height: 1;
            }

            &:focus ~ label {
              display: none;
            }
          }

          label {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            bottom: 0;
            left: 0;
            padding: 4px 24px;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #686868;
            width: 100%;
          }
        }

        .btn {
          background: #F8F8F8;
          border-radius: 14px;
          font-weight: bold;
          font-size: 17px;
          line-height: 20px;
          padding: 16px;
          display: block;
          transition: all 200ms ease;

          &:hover {
            &:not(.disabled) {
              background-color: #cff800;
              color: #000000;
            }
          }

          &.light {
            font-weight: normal;
          }

          &.btn-lg {
            padding: 32px 16px;
            width: 100%;
            margin: 16px 0;
          }

          &.disabled {
            background-color: #F8F8F8 !important;
            border-color: #F8F8F8;
            color: rgba(28, 28, 28, 0.2);
            cursor: default !important;
          }
        }

        .text-error {
          text-align: center;
          font-weight: bold;
          font-size: 12px;
          line-height: 18px;
          color: #FF2B2B;
          padding: 8px 0;
          display: block;
          width: 100%;
        }

        .w-110 {
          width: 110px;
        }

        .w-100 {
          width: 100%;
        }

        .saved {
          font-weight: bold;
          font-size: 25px;
          line-height: 26px;
          text-align: center;
          color: #1C1C1C;
          display: block;
          width: 100%;
          padding: 17px 0;
        }

        &:nth-child(1) {
          float: left;
        }

        &:nth-child(2) {
          float: right;
        }

        &:nth-child(3) {
          float: left;
        }

        &:nth-child(4) {
          float: right;
        }

        &:nth-child(5) {
          float: left;
        }

        &:nth-child(6) {
          float: left;
        }

        &:nth-child(7) {
          float: right;
        }

        &:nth-child(8) {
          float: left;
        }

        &:nth-child(9) {
          float: right;
        }
      }

    }
  }

  .my-bikes-app {
    background: #F8F8F8;
    border-radius: 14px;
    padding: 24px 40px 30px;

    .my-bikes-app__title {
      font-weight: 500;
      font-size: 17px;
      line-height: 1;
      margin-bottom: 16px;
      width: 100%;
      display: block;
      color: #000000;
    }

    .nav-store-wrap {
      display: flex;
      align-items: center;

      .appStore {
        width: 115px;
        margin-right: 10px;
        display: block;

        img {
          max-width: 100%;
          display: block;
        }
      }

      .googlePlay {
        width: 115px;
        display: block;

        img {
          max-width: 100%;
          display: block;
        }
      }
    }
  }

  @media (max-width: 1199px) and (min-width: 992px) {
    .my-bikes-main {
      padding: 24px 20px 40px;

      .my-bikes-main__transfer {
        .item {
          padding: 20px 16px;
          width: calc(50% - 8px);
        }
      }
    }
  }
  @media (max-width: 992px) {
    margin-left: 0;
    .my-bikes-main {
      .my-bikes-main__transfer {
        display: flex;
        flex-wrap: wrap;

        .item {
          float: none;
          width: 100%;

          &:nth-child(1) {
            order: 1;
          }

          &:nth-child(2) {
            order: 2;
          }

          &:nth-child(3) {
            order: 6;
          }

          &:nth-child(4) {
            order: 3;
          }

          &:nth-child(5) {
            order: 7;
          }

          &:nth-child(6) {
            order: 8;
          }

          &:nth-child(7) {
            order: 4;
          }

          &:nth-child(8) {
            order: 9;
          }

          &:nth-child(9) {
            order: 5;
          }
        }
      }

      .my-bikes-main__parameters li {
        font-weight: bold;
        font-size: 32px;
        line-height: 1;
        padding: 4px 10px;

        .gray {
          font-size: 12px;
        }
      }
    }

  }
  @media (max-width: 767px) {
    .my-bikes-main {
      .my-bikes-main__parameters {
        margin-bottom: 32px;

        li {
          font-size: 30px;
          padding: 6px 18px 18px;

          sub, .sub {
            font-size: 14px;
            line-height: 14px;
          }

          .text {
            font-size: 12px;
            line-height: 12px;
          }
        }
      }
    }
  }
  @media (max-width: 575px) {
    .text-pending {
      padding: 0 5px;

      .point {
        width: 3px;
        height: 3px;
      }
    }
    .my-bikes-main {
      margin-bottom: 64px;
      padding: 12px;

      .my-bikes-main__name {
        font-size: 17px;
        line-height: 25px;
        margin: 0 0 6px;
      }

      .my-bikes-main__number {
        font-size: 12px;
        line-height: 18px;
        margin: 0 0 2px;
      }

      .my-bikes-main__des {
        font-size: 12px;
        line-height: 18px;
      }

      .my-bikes-main__parameters {
        grid-template-columns: repeat(2, 1fr);
      }

      .my-bikes-main__transfer {
        margin-bottom: -24px;

        .item {
          padding: 20px 20px;

          .my-bikes-main__transfer--ic {
            width: 55px;
            height: 55px;
          }

          .my-bikes-main__transfer--text {
            width: calc(100% - 55px);
            padding-left: 16px;
          }
        }
      }
    }
    .my-bikes-app {
      padding: 26px 20px 30px;

      .my-bikes-app__title {
        line-height: 25px;
        margin-top: 0;
        margin-bottom: 16px;
      }

      .nav-store-wrap {
        .appStore {
          margin-right: 24px;
        }

        .googlePlay {

        }
      }

    }
  }
  @media (max-width: 575px) {
    .my-bikes-main {
      padding: 12px 8px;

      .my-bikes-main__transfer {
        .item {
          padding: 20px 10px;
        }
      }
    }
  }
  @media (max-width: 350px) {
    .my-bikes-app {

      .nav-store-wrap {
        .appStore {
          width: 100px;
        }

        .googlePlay {
          width: 100px;
        }
      }

    }
  }
}
</style>
